/**
 * ChequeVoidModal — Batch #14.335 : annuler un chèque émis (annulé / perdu) avec motif obligatoire.
 * Le n° reste tracé au registre ; le décaissement est contre-passé (factures de nouveau à payer).
 */
import { useState } from "react";
import { Ban } from "lucide-react";
import { Btn, Modal, inputCls, money } from "../comptabilite/_shared";

export const VOID_KINDS = [["void", "Annulé (erreur, chèque détruit)"], ["lost", "Perdu / volé — opposition à la banque"]];

export default function ChequeVoidModal({ payment, onClose, onConfirm, busy }) {
  const [kind, setKind] = useState("void");
  const [reason, setReason] = useState("");
  const ok = reason.trim().length >= 5;
  return (
    <Modal title={`Annuler le chèque n° ${payment.reference || "—"}`} sub={`${payment.party_name} · ${payment.date} · ${money(payment.amount)}`} onClose={onClose} testId="cheque-void-modal"
      footer={<><Btn tone="slate" onClick={onClose} testId="cheque-void-cancel">Retour</Btn><Btn tone="rose" icon={Ban} disabled={!ok} busy={busy} onClick={() => onConfirm({ kind, reason: reason.trim() })} testId="cheque-void-confirm">Annuler le chèque</Btn></>}>
      <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
        Le n° <b>{payment.reference || "—"}</b> reste tracé au registre des chèques avec votre motif. Le décaissement est <b>contre-passé</b> (écriture annulée ou supprimée) et
        {payment.allocations?.length ? ` les ${payment.allocations.length} facture(s) redeviennent à payer` : " l'acompte disparaît"} — émettez ensuite un nouveau chèque si nécessaire.
      </p>
      <label className="block text-xs font-medium text-slate-600 mt-3 mb-1">Type</label>
      <select value={kind} onChange={(e) => setKind(e.target.value)} className={inputCls} data-testid="cheque-void-kind">
        {VOID_KINDS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      <label className="block text-xs font-medium text-slate-600 mt-3 mb-1">Motif * <span className="text-slate-400 font-normal">(5 caractères min.)</span></label>
      <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} className={inputCls} maxLength={300} placeholder="Ex. Chèque perdu par la poste — opposition faite le 2026-10-22" data-testid="cheque-void-reason" autoFocus />
    </Modal>
  );
}
